import { USER_REFRESH_TOKEN_NAME } from './configs/constants/index.js';

var authCookies = [USER_REFRESH_TOKEN_NAME, 'user_email', 'is_subscribed', 'UI', 'gtm_user_id', 'badges', 'CUbadge', 'verify_email', 'eth_user', 'eth_update', 'forcedExperimentVariant', 'forcedExperimentId'];
var logoutRedirectionPage = '/';
var authorizeRequiredPages = ['create', 'settings', 'explore'];

export { authCookies as a, authorizeRequiredPages as b, logoutRedirectionPage as l };
//# sourceMappingURL=constants-564e5651.js.map
